import React from 'react';

import { Box } from '@provider-portal/design-common/kalep/components/Box/Box';
import { Button } from '@provider-portal/design-common/kalep/components/Button/Button';
import { Typography } from '@provider-portal/design-common/kalep/components/Typography/Typography';
import { useIntl } from 'react-intl';

export type StoreSelectorHeaderStrings = Record<'yourVenue' | 'addVenue', string>;
export interface StoreSelectorHeaderProps {
  showAddVenueButton: boolean;
  onAddVenue?: () => void;
}
export function StoreSelectorHeader({ onAddVenue, showAddVenueButton }: StoreSelectorHeaderProps) {
  const intl = useIntl();
  const yourVenue = intl.formatMessage({ id: 'venueSelector.header.selectVenue' });
  const addVenue = intl.formatMessage({ id: 'venueSelector.header.addVenue' });

  const handleAddVenue = React.useCallback(() => {
    if (onAddVenue) {
      onAddVenue();
    }
  }, [onAddVenue]);
  return (
    <Box
      display="flex"
      gap="12px"
      alignItems="center"
      justifyContent="space-between"
      mb="4px"
      py="12px"
    >
      <Box>
        <Typography variant="heading-xs-accent">{yourVenue}</Typography>
      </Box>
      {showAddVenueButton && (
        <Box>
          <Button color="secondary" size="small" onClick={handleAddVenue}>
            {addVenue}
          </Button>
        </Box>
      )}
    </Box>
  );
}
